import { useQuery } from '@tanstack/react-query';
import { Crosshair, Map, Shield } from 'lucide-react';
import React from 'react';
import { BsArrowClockwise } from 'react-icons/bs';
import { FaBullseye } from 'react-icons/fa';

import { fetchUserStats } from '../api/getUserStats';

interface UserStatsProps {
  steamid?: string;
}
const UserStats: React.FC<UserStatsProps> = ({ steamid }) => {
  const { data: stats } = useQuery({
    queryKey: ['stats', steamid],
    queryFn: () => fetchUserStats(steamid ?? ''),
    enabled: !!steamid,
  });

  return (
    <div>
      <div className="mb-3 text-lg font-semibold">Statistics</div>
      <div className="grid grid-cols-2 gap-x-8 gap-y-4 sm:grid-cols-4 lg:grid-cols-5">
        <div className="flex h-48 flex-col items-center justify-center gap-y-2.5 rounded-md border border-border px-6 py-4 text-center text-xs">
          <h3 className="text-4xl font-semibold lg:text-5xl">
            {stats?.mapsCount ? stats.mapsCount : 0}
          </h3>
          <p className="font-semibold uppercase text-muted-foreground">Maps</p>
          <Map className="text-primary" />
        </div>
        <div className="flex h-48 flex-col items-center justify-center gap-y-2.5 rounded-md border border-border px-6 py-4 text-center text-xs">
          <h3 className="text-4xl font-semibold lg:text-5xl">
            {stats?.kdRatio ? stats.kdRatio : '-'}
          </h3>
          <p className="font-semibold uppercase text-muted-foreground">
            K/D ratio
          </p>
          <Shield className="text-primary" />
        </div>
        <div className="flex h-48 flex-col items-center justify-center gap-y-2.5 rounded-md border border-border px-6 py-4 text-center text-xs">
          <h3 className="text-4xl font-semibold lg:text-5xl">
            {stats?.averageKills ? stats.averageKills : '-'}
          </h3>
          <p className="font-semibold uppercase text-muted-foreground">
            Average kills
          </p>
          <Crosshair className="text-primary" />
        </div>
        <div className="flex h-48 flex-col items-center justify-center gap-y-2.5 rounded-md border border-border px-6 py-4 text-center text-xs">
          <h3 className="text-4xl font-semibold lg:text-5xl">
            {stats?.killsPerRound ? stats.killsPerRound : '-'}
          </h3>
          <p className="font-semibold uppercase text-muted-foreground">
            Kills per round
          </p>
          <BsArrowClockwise className="text-primary" />
        </div>
        <div className="flex h-48 flex-col items-center justify-center gap-y-2.5 rounded-md border border-border px-6 py-4 text-center text-xs">
          <h3 className="text-4xl font-semibold lg:text-5xl">
            {stats?.hsPercentage ? stats.hsPercentage + '%' : '-'}
          </h3>
          <p className="font-semibold uppercase text-muted-foreground">
            Headshot percent
          </p>
          <FaBullseye className="text-primary" />
        </div>
      </div>
    </div>
  );
};

export { UserStats };
